import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from 'react';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { QRCode } from 'react-qr-code';

import './diploma.css';

import logo from '../header/images/logo.png';
import ribbondiploma from '../imagesHome/ribbondiploma.png';
import logocontadiploma from '../imagesHome/logoconta.png';


const DIPLOMA_WIDTH = 1123;
const DIPLOMA_HEIGHT = 794;


const Diploma = ({
  courseId = 1,
  previewUser = null,
  previewMode = false,
  certificateData = null,
  publicView = false
}) => {

  const diplomaRef = useRef(null);
  const viewportRef = useRef(null);

  const [user, setUser] = useState(null);
  const [certificate, setCertificate] = useState(null);

  const [scale, setScale] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  /* =========================
     INCARCARE USER
  ========================= */

  useEffect(() => {

    /* DACA PRIMIM CERTIFICAT PUBLIC */

    if (certificateData) {

      setUser({
        username: certificateData.student_name
      });

      return;

    }


    /* PREVIEW */

    if (previewUser) {

      setUser(previewUser);

      return;

    }


    /* USER AUTENTIFICAT */

    fetch(
      `${process.env.REACT_APP_API_URL}/user`,
      {
        credentials: 'include'
      }
    )
      .then(async res => {

        if (!res.ok) {
          throw new Error(
            'Utilizatorul nu a putut fi incarcat'
          );
        }

        return res.json();

      })
      .then(data => {

        setUser(data);

      })
      .catch(error => {

        console.error(
          'Eroare la incarcarea utilizatorului:',
          error
        );

        setError(
          'Utilizatorul nu a putut fi incarcat'
        );

      });

  }, [
    previewUser,
    certificateData
  ]);


  /* =========================
     INCARCARE CERTIFICAT
  ========================= */

  useEffect(() => {

    /* =========================
       CERTIFICAT PRIMIT DIRECT
    ========================= */

    if (certificateData) {

      setCertificate(certificateData);
      setLoading(false);
      setError(null);

      return;

    }


    /* =========================
       PREVIEW
    ========================= */

    if (previewMode) {

      setCertificate({
        certificate_code: 'CL-8F42K91',
        student_name:
          previewUser?.username || 'Andrei Popescu',
        course_name: 'Bazele contabilitatii',
        completed_at: new Date().toISOString(),
        issued_at: new Date().toISOString(),
        status: 'valid'
      });

      setLoading(false);

      return;

    }


    /* =========================
       CERTIFICAT USER AUTENTIFICAT
    ========================= */

    if (!courseId) {
      return;
    }


    setLoading(true);
    setError(null);


    fetch(
      `${process.env.REACT_APP_API_URL}/certificates/course/${courseId}`,
      {
        credentials: 'include'
      }
    )
      .then(async res => {

        if (res.status === 404) {
          throw new Error(
            'Nu exista certificat pentru acest curs'
          );
        }


        if (!res.ok) {
          throw new Error(
            'Certificatul nu a putut fi incarcat'
          );
        }


        return res.json();

      })
      .then(data => {

        setCertificate(data);
        setLoading(false);

      })
      .catch(error => {

        console.error(
          'Eroare la incarcarea certificatului:',
          error
        );

        setError(error.message);
        setLoading(false);

      });

  }, [
    courseId,
    previewMode,
    previewUser,
    certificateData
  ]);


  /* =========================
     REDIMENSIONARE DIPLOMA
  ========================= */

  useLayoutEffect(() => {

    if (
      !user ||
      !certificate ||
      !viewportRef.current
    ) {
      return;
    }


    const viewport =
      viewportRef.current;


    const updateScale = () => {

      const availableWidth =
        viewport.clientWidth;


      if (!availableWidth) {
        return;
      }


      const newScale = Math.min(
        availableWidth / DIPLOMA_WIDTH,
        1
      );


      setScale(newScale);

    };


    updateScale();


    const resizeObserver =
      new ResizeObserver(() => {
        updateScale();
      });


    resizeObserver.observe(viewport);


    window.addEventListener(
      'resize',
      updateScale
    );


    return () => {

      resizeObserver.disconnect();

      window.removeEventListener(
        'resize',
        updateScale
      );

    };

  }, [
    user,
    certificate
  ]);


  /* =========================
     DESCARCARE PDF
  ========================= */

  const downloadPDF = async () => {

    if (
      !diplomaRef.current ||
      !user ||
      !certificate
    ) {
      return;
    }


    try {

      const canvas =
        await html2canvas(
          diplomaRef.current,
          {
            scale: 3,
            useCORS: true,
            backgroundColor: '#ffffff'
          }
        );


      const imgData =
        canvas.toDataURL('image/png');


      const pdf = new jsPDF(
        'landscape',
        'px',
        [
          DIPLOMA_WIDTH,
          DIPLOMA_HEIGHT
        ]
      );


      pdf.addImage(
        imgData,
        'PNG',
        0,
        0,
        DIPLOMA_WIDTH,
        DIPLOMA_HEIGHT
      );


      const safeUsername =
        certificate.student_name
          ?.replace(/\s+/g, '_')
          ?.replace(
            /[^a-zA-Z0-9_-]/g,
            ''
          ) || 'certificat';


      pdf.save(
        `${safeUsername}_certificat.pdf`
      );


    } catch (error) {

      console.error(
        'Eroare la generarea PDF-ului:',
        error
      );

    }

  };


  /* =========================
     LOADING
  ========================= */

  if (loading) {
    return null;
  }


  /* =========================
     EROARE
  ========================= */

  if (error) {

    return (

      <div className="diploma-component">

        <div className="diploma-error">
          {error}
        </div>

      </div>

    );

  }


  if (!user || !certificate) {
    return null;
  }


  /* =========================
     DATE CERTIFICAT
  ========================= */

  const certificateCode =
    certificate.certificate_code;


  const verifyUrl =
    `${window.location.origin}/verify/${certificateCode}`;


  const completedDate =
    certificate.completed_at
      ? new Date(
          certificate.completed_at
        ).toLocaleDateString('ro-RO')
      : '';


  const studentName =
    certificate.student_name ||
    user.username;


  const courseName =
    certificate.course_name ||
    'Bazele contabilitatii';


  return (

    <div className="diploma-component">


      {/* =========================
          ZONA RESPONSIVE
      ========================= */}

      <div
        ref={viewportRef}
        className="diploma-viewport"
        style={{
          height:
            `${DIPLOMA_HEIGHT * scale}px`
        }}
      >


        {/* =========================
            CONTAINER SCALAT
        ========================= */}

        <div
          className="diploma-scale-container"
          style={{
            transform:
              `translateX(-50%) scale(${scale})`
          }}
        >


          {/* =========================
              DIPLOMA REALA
          ========================= */}

          <div
            ref={diplomaRef}
            className="diploma-wrapper"
          >

            <div className="diploma-outer-border">

              <div className="diploma-border">


                <div className="diploma-top-logo">

                  <img
                    src={logo}
                    alt="ContaLearn"
                  />

                </div>


                <div className="diploma-title">
                  Certificat de competente
                </div>


                <div className="diploma-text">
                  Se acorda prezentul certificat lui
                </div>


                <div className="diploma-name">
                  {studentName}
                </div>


                <div className="diploma-text">
                  pentru finalizarea cu succes a cursului
                </div>


                <div className="diploma-course">
                  {courseName}
                </div>


                <div className="ribbon-wrapper">

                  <img
                    src={ribbondiploma}
                    className="ribbon-diploma"
                    alt=""
                  />

                </div>


                <div className="diploma-bottom-row">


                  {/* QR */}

                  <div className="bottom-col left">

                    <div className="verification-area">

                      <div className="verification-qr">

                        <QRCode
                          value={verifyUrl}
                          size={80}
                        />

                      </div>


                      <div className="verification-info">

                        <span className="verify-text">
                          {certificateCode}
                        </span>

                      </div>

                    </div>

                  </div>


                  {/* DATA + EMITENT */}

                  <div className="bottom-col center">

                    <div className="line-top-datas" />


                    <div className="diploma-issuer-area">


                      <div className="issue-date-block">

                        <span className="issue-date-value">
                          {completedDate}
                        </span>

                        <span className="issue-date-label">
                          Data finalizarii
                        </span>

                      </div>


                      <div className="issuer-block">

                        <span className="issuer-name">
                          ContaLearn
                        </span>

                        <span className="issuer-label">
                          Certificat verificabil
                        </span>

                      </div>


                    </div>

                  </div>


                  {/* BADGE */}

                  <div className="bottom-col right">

                    <div className="badge-signature">

                      <div className="badge-ring">

                        <div className="badge-inner">

                          <img
                            src={logocontadiploma}
                            alt="Curs completat"
                          />

                        </div>


                        <svg
                          className="badge-text-circle"
                          viewBox="0 0 200 200"
                        >

                          <defs>

                            <path
                              id="circlePath"
                              d="
                                M 100, 100
                                m -75, 0
                                a 75,75 0 1,1 150,0
                                a 75,75 0 1,1 -150,0
                              "
                            />

                          </defs>


                          <text>

                            <textPath
                              href="#circlePath"
                              startOffset="50%"
                              textAnchor="middle"
                            >
                              CURS ★ COMPLETAT ★ CONTALEARN
                            </textPath>

                          </text>

                        </svg>

                      </div>

                    </div>

                  </div>


                </div>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =========================
          BUTON PDF
      ========================= */}

      {!previewMode && (

        <div
          className={
            publicView
              ? 'certification-download-btn'
              : 'download-btn'
          }
          onClick={downloadPDF}
        >
          <p>
            Descarca diploma (PDF)
          </p>
        </div>

      )}


    </div>

  );

};


export default Diploma;